/* wellinda-contact-stages — four-step contact flow over Shopify's native
   contact form. The visible inputs carry no name; their values are copied into
   the hidden contact[...] fields just before the form posts, so a half-filled
   wizard can never submit. Self-contained, no dependencies. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.wconReady === 'true') return;
    root.dataset.wconReady = 'true';

    var form = root.querySelector('form');
    var flow = root.querySelector('[data-wcon-flow]');
    var thanks = root.querySelector('[data-wcon-thanks]');
    var alertBox = root.querySelector('[data-wcon-alert]');
    var steps = root.querySelectorAll('[data-wcon-step]');
    var panels = root.querySelectorAll('[data-wcon-panel]');
    var chips = root.querySelectorAll('[data-wcon-chip]');
    var modal = root.querySelector('[data-wcon-modal]');
    var textarea = root.querySelector('[data-wcon-textarea]');
    var writeBtn = root.querySelector('[data-wcon-open-modal]');
    var submitBtn = root.querySelector('[data-wcon-submit]');
    var reviewBack = root.querySelector('[data-wcon-back="4"]');
    var editBtns = root.querySelectorAll('[data-wcon-edit]');
    var writeLabel = writeBtn ? writeBtn.textContent.trim() : 'Write a message';
    var isSubmitting = false;

    var hidden = {
      issue: root.querySelector('[data-wcon-hidden="issue"]'),
      first: root.querySelector('[data-wcon-hidden="first"]'),
      last: root.querySelector('[data-wcon-hidden="last"]'),
      email: root.querySelector('[data-wcon-hidden="email"]'),
      message: root.querySelector('[data-wcon-hidden="message"]')
    };
    var fields = {
      first: root.querySelector('[data-wcon-field="first"]'),
      last: root.querySelector('[data-wcon-field="last"]'),
      email: root.querySelector('[data-wcon-field="email"]')
    };
    var review = {
      issue: root.querySelector('[data-wcon-review="issue"]'),
      name: root.querySelector('[data-wcon-review="name"]'),
      email: root.querySelector('[data-wcon-review="email"]'),
      messageTitle: root.querySelector('[data-wcon-review="message-title"]'),
      message: root.querySelector('[data-wcon-review="message"]')
    };

    var state = { step: 1, issue: '', message: '' };

    /* ---------------------------------------------------------- helpers */

    function showAlert(text) {
      if (!alertBox) return;
      alertBox.textContent = text || '';
      alertBox.classList.toggle('is-visible', !!text);
    }

    function markError(el, on) {
      if (el) el.classList.toggle('has-error', !!on);
    }

    function isEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
    }

    // built by hand: toLocaleDateString('en-GB') now returns "Sept", not "Sep"
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function messageDate() {
      var now = new Date();
      return now.getDate() + ' ' + MONTHS[now.getMonth()] + ' ' + now.getFullYear();
    }

    function setSubmitting(on) {
      isSubmitting = !!on;
      if (submitBtn) {
        submitBtn.classList.toggle('is-loading', isSubmitting);
        submitBtn.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      }
      if (reviewBack) reviewBack.disabled = isSubmitting;
      for (var i = 0; i < editBtns.length; i++) editBtns[i].disabled = isSubmitting;
    }

    /* ------------------------------------------------------ navigation */

    function goTo(step, skipScroll) {
      state.step = step;

      for (var i = 0; i < panels.length; i++) {
        panels[i].classList.toggle(
          'is-current',
          Number(panels[i].getAttribute('data-wcon-panel')) === step
        );
      }

      for (var j = 0; j < steps.length; j++) {
        var n = Number(steps[j].getAttribute('data-wcon-step'));
        steps[j].classList.toggle('is-active', n === step);
        steps[j].classList.toggle('is-done', n < step);
      }

      showAlert('');
      if (step === 4) renderReview();

      if (!skipScroll && root.getBoundingClientRect().top < 0) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function validate(step) {
      if (step === 1) {
        if (!state.issue) {
          showAlert('Please choose a topic to continue.');
          return false;
        }
        return true;
      }

      if (step === 2) {
        var ok = true;
        if (!fields.first.value.trim()) { markError(fields.first, true); ok = false; }
        else markError(fields.first, false);
        if (!fields.last.value.trim()) { markError(fields.last, true); ok = false; }
        else markError(fields.last, false);
        if (!isEmail(fields.email.value)) { markError(fields.email, true); ok = false; }
        else markError(fields.email, false);
        if (!ok) showAlert('Please fill in your name and a valid email address.');
        return ok;
      }

      if (step === 3) {
        if (!state.message.trim()) {
          showAlert('Please write a message before continuing.');
          return false;
        }
        return true;
      }

      return true;
    }

    function renderReview() {
      if (review.issue) review.issue.textContent = state.issue;
      if (review.name) {
        review.name.textContent = (fields.first.value.trim() + ' ' + fields.last.value.trim()).trim();
      }
      if (review.email) review.email.textContent = fields.email.value.trim();
      if (review.messageTitle) {
        review.messageTitle.textContent = 'Text Message - ' + messageDate();
      }
      if (review.message) review.message.textContent = state.message;
    }

    function syncHidden() {
      hidden.issue.value = state.issue;
      hidden.first.value = fields.first.value.trim();
      hidden.last.value = fields.last.value.trim();
      hidden.email.value = fields.email.value.trim();
      hidden.message.value = state.message;
    }

    /* typing in a flagged field clears its error straight away */
    Object.keys(fields).forEach(function (key) {
      var el = fields[key];
      if (!el) return;
      el.addEventListener('input', function () {
        if (!el.classList.contains('has-error')) return;
        markError(el, false);
        if (!root.querySelector('.has-error')) showAlert('');
      });
    });

    /* ----------------------------------------------------------- chips */

    for (var c = 0; c < chips.length; c++) {
      (function (chip) {
        chip.addEventListener('click', function () {
          state.issue = chip.value || chip.textContent.trim();
          for (var k = 0; k < chips.length; k++) {
            chips[k].setAttribute('aria-pressed', String(chips[k] === chip));
          }
          showAlert('');
        });
      })(chips[c]);
    }

    /* ----------------------------------------------------------- modal */

    function openModal() {
      if (!modal) return;
      modal.classList.add('is-open');
      textarea.value = state.message;
      textarea.focus();
    }

    function closeModal() {
      if (modal) modal.classList.remove('is-open');
    }

    if (writeBtn) writeBtn.addEventListener('click', openModal);

    var closeBtn = root.querySelector('[data-wcon-close-modal]');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
    });

    var saveBtn = root.querySelector('[data-wcon-save]');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        state.message = textarea.value;
        if (writeBtn) {
          writeBtn.classList.toggle('is-filled', !!state.message.trim());
          writeBtn.textContent = state.message.trim() ? 'Edit your message' : writeLabel;
        }
        closeModal();
        showAlert('');
      });
    }

    /* --------------------------------------------------- step buttons */

    root.querySelectorAll('[data-wcon-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var from = Number(btn.getAttribute('data-wcon-next'));
        if (validate(from)) goTo(from + 1);
      });
    });

    root.querySelectorAll('[data-wcon-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(Number(btn.getAttribute('data-wcon-back')) - 1);
      });
    });

    for (var e = 0; e < editBtns.length; e++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          goTo(Number(btn.getAttribute('data-wcon-edit')));
        });
      })(editBtns[e]);
    }

    /* ---------------------------------------------------------- submit */

    if (form) {
      form.addEventListener('submit', function (event) {
        if (isSubmitting) {
          event.preventDefault();
          return;
        }
        if (!validate(1) || !validate(2) || !validate(3)) {
          event.preventDefault();
          goTo(!state.issue ? 1 : 2);
          return;
        }
        syncHidden();
        setSubmitting(true);
      });
    }

    // the browser can restore this page from bfcache with the button still spinning
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) setSubmitting(false);
    });

    /* --------------------------------------------------------- restart */

    root.querySelectorAll('[data-wcon-restart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.issue = '';
        state.message = '';
        for (var k = 0; k < chips.length; k++) chips[k].setAttribute('aria-pressed', 'false');
        Object.keys(fields).forEach(function (key) {
          fields[key].value = '';
          markError(fields[key], false);
        });
        Object.keys(hidden).forEach(function (key) {
          hidden[key].value = '';
        });
        if (textarea) textarea.value = '';
        if (writeBtn) {
          writeBtn.textContent = writeLabel;
          writeBtn.classList.remove('is-filled');
        }
        setSubmitting(false);
        thanks.classList.remove('is-current');
        flow.style.display = '';
        if (window.history.replaceState) {
          window.history.replaceState({}, '', window.location.pathname);
        }
        goTo(1);
      });
    });

    goTo(state.step, true);

    // Shopify renders the thank-you panel server-side after a successful post
    if (thanks && thanks.classList.contains('is-current')) {
      flow.style.display = 'none';
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-wcon-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('[data-wcon-root]');
    if (el) init(el);
  });
})();
